export default "__VITE_ASSET__12c8c468__"